const LOCAL_BACKEND_ORIGIN = "http://127.0.0.1:8000";
const MEDIA_KEY_PATTERN =
  /(img|image|pic|cover|poster|icon|ico|avatar|banner|thumb|video|play_url|pvideo|url)$/i;

function getBackendOrigin() {
  const configuredOrigin = String(process.env.VUE_APP_BACKEND_ORIGIN || "").trim();
  if (configuredOrigin) {
    return configuredOrigin.replace(/\/+$/, "");
  }

  if (typeof window === "undefined" || !window.location) {
    return LOCAL_BACKEND_ORIGIN;
  }

  const { hostname, origin } = window.location;
  if (hostname === "127.0.0.1" || hostname === "localhost") {
    return LOCAL_BACKEND_ORIGIN;
  }

  return origin.replace(/\/+$/, "");
}

function normalizeLocalPath(pathname = "") {
  return `/${String(pathname).replace(/^\/+/, "")}`;
}

export function normalizeMediaUrl(value) {
  const input = String(value || "").trim();
  const backendOrigin = getBackendOrigin();
  if (!input) {
    return "";
  }

  if (/^data:|^blob:/i.test(input)) {
    return input;
  }

  if (input.startsWith("//")) {
    return `${backendOrigin}${normalizeLocalPath(input)}`;
  }

  if (/^https?:\/\//i.test(input)) {
    try {
      const parsed = new URL(input);
      if (
        (parsed.hostname === "127.0.0.1" || parsed.hostname === "localhost") &&
        !parsed.port
      ) {
        return `${backendOrigin}${normalizeLocalPath(parsed.pathname)}${parsed.search}${parsed.hash}`;
      }
      return parsed.toString();
    } catch (error) {
      return input;
    }
  }

  if (/^(video|storage|uploads?)\//i.test(input) || input.startsWith("/")) {
    return `${backendOrigin}${normalizeLocalPath(input)}`;
  }

  return input;
}

export function normalizeMediaPayload(value, parentKey = "") {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeMediaPayload(item, parentKey));
  }

  if (value && typeof value === "object") {
    return Object.keys(value).reduce((result, key) => {
      result[key] = normalizeMediaPayload(value[key], key);
      return result;
    }, {});
  }

  if (typeof value === "string" && MEDIA_KEY_PATTERN.test(parentKey)) {
    return normalizeMediaUrl(value);
  }

  return value;
}
